import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

import type { ITooltipAngularComp } from 'ag-grid-angular';
import type { ITooltipParams } from 'ag-grid-community';

@Component({
    standalone: true,
    imports: [CommonModule],
    template: ` <div class="custom-tooltip" style="background-color: #fff; width: 600px; padding: 0px;
    border: solid #ccc 1px; max-height: 300px; overflow-y: auto">
        
        <div style="padding: 8px 0 8px 10px;"><b>Modified Data:</b></div>
        <div class="table-responsive-sm">
            <table class="table table-striped table-bordered mb-0" *ngIf="payload_data_arr.length">
                <tbody>
                    <tr class="table-light" *ngFor="let item of payload_data_arr">
                        <td style="padding: 3px 5px 3px 10px; font-weight: 500">{{item.label}}</td>
                        <td style="padding: 3px 10px 3px 5px">{{item.value}}</td>
                    </tr>
                </tbody>
            </table>
        </div>  
    </div>`,
    styles: [
        `
            // :host {
            //     position: absolute;
            //     pointer-events: none;
            //     transition: opacity 1s;
            // }

            // :host.ag-tooltip-hiding {
            //     opacity: 0;
            // }

            // .custom-tooltip p {
            //     margin: 5px;
            //     white-space: nowrap;
            // }

            // .custom-tooltip p:first-of-type {
            //     font-weight: bold;
            // }
        `,
    ],
})
export class WflogsTooltip implements ITooltipAngularComp {
    params!: { color: string } & ITooltipParams;
    payload: any;
    payload_data_arr: Array<any>;

    agInit(params: { color: string } & ITooltipParams): void {
        this.payload = params.data?.payload ? params.data?.payload : '';
        // const partner_name = params.data?.payload?.partner_name;
        this.payload_data_arr = [];
        // this.payload_data_arr.push(
        //     {
        //         label: 'csp_name',
        //         value: partner_name ? partner_name : ''
        //     });
        if (Object.keys(this.payload).length) {
            for (const [key, value] of Object.entries(this.payload)) {
                let label = `${key}`;
                const val = value == null ? '' : `${value}`;
                if (this.lablesToPass(label)) {
                    label = (label === 'partner_name') ? 'csp_name' : label;
                    this.payload_data_arr.push(
                        {
                            label: label ? label : '',
                            value: val ? val : ''
                        }
                    )
                }

            }
        }
    }

    lablesToPass(label: string) {
        return true;
        // return label !== 'app_id'
        //     && label !== 'partner_id'
        //     && label !== 'tier_id'
        //     && label !== 'vendor_id'
    }
}